import { size, find } from "lodash";
import get from "lodash/get";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import "react-toastify/dist/ReactToastify.css";
import { ShowWarningsModal } from "../../../components/modals/ShowWarningsModal";
import AssessmentWarnings from "../../../pages/assessment/assessmentWarnings";
import ConfirmationModal from "../../../components/modals/ConfirmationModal";
import ElabSubmissionStatus from "../../components/ElabSubmissionStatus";
import SaveQuizOnRefresh from "../../../pages/quiz/QuizSubmit";
import VisualizerModel from "../../../components/modals/VisualizerModel";
import SystemRequirementsModal from "../../../components/modals/SystemRequirementsModal";
import AssessmentPayLoadMakerHelper from "../../../pages/assessment/assessmentPayLoaderMaker";
import { ElabAssessmentRunner } from "./ElabAssessmentRunner";
import {
  AccountType,
  exerciseType,
  assessmentFlow,
  DirectSubmission,
} from "../../../components/constants/constants";
import { toast, ToastContainer } from "react-toastify";
import ElabWaitModel from "../../modals/ElabWaitModel";
import { MobileViewProvider } from "../../../speech_pages/components/MobileViewContext";

let answers = [];
let pushed = false;
let is_saved_assessment = false;
let is_show_assessment_warning = false;
let changed_is_submit_state = false;

export const type = {
  Exercise: "Exercise",
  Assessment: "Assessment",
};

export default function ElabAssessment({
  data,
  onSubmit,
  isReview,
  isSubmitting,
  setIsSystemRedirection,
  isSystemRedirection,
}) {
  const [isSubmit, setIsSubmit] = useState(false);
  const [message, setMessage] = useState("Please wait whilst we redirect you ...");
  const [showTimeWarning, setShowTimeWarning] = useState(false);

  // Extracting test_section_id from URL parameters
  const params = new URL(document.location).searchParams;
  const test_section_id = params.get("section_id");

  // Time warning logic
  if (showTimeWarning && !is_show_assessment_warning) {
    const timer1 = window.sessionStorage.getItem(
      "timer" + data.student_assessment_id
    );
    const time = parseInt(timer1 / 60);
    if (time < 1) {
      is_show_assessment_warning = true;
      toast.error(`You have less than ${timer1} seconds left`, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        toastId: 1,
      });
    } else {
      is_show_assessment_warning = true;
      toast.error(`You have ${time} minutes left`, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        toastId: 1,
      });
    }
  }
  const [assessmentTimer, setAssessmentTimer] = useState();
  const [assessmentStarted, setAssessmentStarted] = useState(false);
  const [modal, setModal] = useState(false);
  const [resetAudio, setresetAudio] = useState(false);
  let [showWarning, setShowWarnings] = useState();
  const [notAnsweredQuestion, setNotAnsweredQuestions] = useState("");
  const toggle = () => setModal(!modal);
  const [saveModal, setSaveModal] = useState(false);

  const [waitModal, setWaitModel] = useState(false);
  const waitToggle = () => setWaitModel(!waitModal);

  const [visualizerModal, setVisualizerModal] = useState(false);
  const visualizerToggle = () => setVisualizerModal(!visualizerModal);
  const [systemrequirementModal, setSystemRequirementModal] = useState(false);
  const systemrequirementToggle = () =>
    setSystemRequirementModal(!systemrequirementModal);

  const [isOpenAdditionalResourceModal, setOpenAdditionalResourceModal] =
    useState(false);

  const additionalResourceToggle = () =>
    setOpenAdditionalResourceModal(!isOpenAdditionalResourceModal);
  const saveToggle = () => setSaveModal(!saveModal);
  const [isStopTimer, setIsStopTimer] = useState(false);
  const [IsonRecorder, setIsonRecorder] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [questions, setQuestions] = useState([]);
  const [essayWordsCount, setessayWordsCount] = useState(0);
  

  useEffect(() => {
    if (
      data &&
      data.type === type.Assessment &&
      !test_section_id &&
      size(data?.sections_pages) === 0 &&
      !changed_is_submit_state
    ) {
      changed_is_submit_state = true;
      setIsSubmit(true);
      waitToggle();
    }
  }, [data, test_section_id]);

  useEffect(() => {
    if (
      data.completed_at &&
        data.completed_at !== null &&
        data.type === type.Assessment
    ) {
      setIsSystemRedirection(true);
    } else if (isSubmit) {
      setIsSystemRedirection(true);
    } else {
      setIsSystemRedirection(false);
    }
    if (
      data &&
      data.is_browse_alert &&
      data.user_type === AccountType.STUDENT &&
      !isSystemRedirection
    ) {
      window.addEventListener("beforeunload", alertUser);
      return () => {
        window.removeEventListener("beforeunload", alertUser);
      };
    }
  });
  const alertUser = (e) => {
    if (
      data &&
      data.is_browse_alert &&
      data.user_type === AccountType.STUDENT
    ) {
      e.preventDefault();
      e.returnValue = "";
    }
  };

  useEffect(() => {
    let parsed_data_from_local_storage;

    if (data && data.status === "In progress" && !data.completed_at) {
      let fetch_data_from_local_storage = localStorage.getItem(
        `assessment${data.id}${data.school_student_id}${data.student_assessment_id}`
      );
      if (fetch_data_from_local_storage && !pushed) {
        parsed_data_from_local_storage = JSON.parse(
          fetch_data_from_local_storage
        );
        answers = parsed_data_from_local_storage.answers;
        if (parsed_data_from_local_storage.time_spent) {
          setAssessmentTimer(parsed_data_from_local_storage.time_spent);
        }

        pushed = true;
      } else if (!fetch_data_from_local_storage) {
        setAssessmentTimer("00");
      }
    } else if (data && data.status === "New") {
      setAssessmentTimer("00");
    }
  }, [data]);

  useEffect(() => {
    setQuestions(get(data, "questions"));
  }, [data]);

  const creatQuizDataAndSubmit = (grading_ai) => {
    AssessmentSubmit();
  };
  const AssessmentSubmit = () => {
    const timer = window.sessionStorage.getItem(
      "timer" + data.student_assessment_id
    );
    data &&
      data.sections &&
      data.sections.forEach((section) => {
        section &&
          section.pages &&
          section.pages.forEach((page) => {
            if (size(page.exercises) > 0) {
              page &&
                page.exercises &&
                page.exercises.forEach((exercise) => {
                  let found_page = find(answers, ["page_id", page.id]);
                  let found_exercise = find(answers, [
                    "exercise_id",
                    exercise.id,
                  ]);
                  if (!found_page && !found_exercise) {
                    answers.push({
                      section_id: section.id,
                      page_id: page.id,
                      exercise_id: exercise.id,
                      answers: [],
                    });
                  } else if (size(exercise.questions) > 0) {
                    exercise &&
                      exercise.questions?.forEach((question) => {
                        if (question.type === "FillInBlank") {
                          let found_from_answer = find(found_exercise.answers, [
                            "question_id",
                            question.id,
                          ]);
                          if (found_from_answer) {
                            question.prompt_content.replace(
                              /\[\[[^\]]*\]\]/g,
                              function replacer(matched) {
                                let number = parseInt(matched.match(/\d+/)[0]);
                                let found_from_selected_answers = find(
                                  found_from_answer.selected_answers,
                                  ["number", number]
                                );
                                if (!found_from_selected_answers) {
                                  found_from_answer.selected_answers.push({
                                    number: number,
                                    answer: "",
                                  });
                                }
                              }
                            );
                          }
                        }
                      });
                  }
                });
            } else if (size(page.writing_exercises) > 0) {
              page &&
                page.writing_exercises &&
                page.writing_exercises.forEach((exercise) => {
                  let found_page = find(answers, ["page_id", page.id]);
                  let found_exercise = find(answers, [
                    "exercise_id",
                    exercise.id,
                  ]);
                  if (!found_exercise && !found_page) {
                    answers.push({
                      section_id: section.id,
                      page_id: page.id,
                      exercise_id: exercise.id,
                      answers: "",
                    });
                  }
                });
            }
          });
      });

    const spent_timer = parseInt(data.time_allowed_in_minutes * 60 - timer);
    let tempAns = answers;
    answers = [];
    let quiz_data = {
      is_submit: true,
      time_spent: parseInt(spent_timer),
      assessment_id: data.id,
      student_assessment_payload: tempAns,
    };
    if (data.assessment_flow !== assessmentFlow.SEQUENTIAL_EARLY_STOP) {
      setIsStopTimer(true);
    }
    if (data.assessment_flow === assessmentFlow.SEQUENTIAL) {
      onSubmit(quiz_data);
      setIsSubmit(true);
      waitToggle();
    } else if (size(data.sections_pages) === 1) {
      onSubmit(quiz_data);
      setIsStopTimer(true);
      setIsSubmit(true);
      setSaveModal(false);
    } else {
      onSubmit(quiz_data, false);
    }
    setShowWarnings(false);
    setresetAudio(true);
    if (modal === true) {
      toggle();
    } else if (data.assessment_flow !== assessmentFlow.SEQUENTIAL_EARLY_STOP) {
      setSaveModal(false);
    }
  };

  const AssessmentSave = () => {
    const timer = window.sessionStorage.getItem(
      "timer" + data.student_assessment_id
    );
    localStorage.setItem(
      `assessment${data.id}${data.school_student_id}${data.student_assessment_id}`,
      JSON.stringify({ time_spent: parseInt(timer), answers })
    );
    setIsStopTimer(false);
  };

  const AssessmentStatusChangeCall = () => {
    let quiz_data = {
      is_submit: false,
    };
    if (!is_saved_assessment) {
      is_saved_assessment = true;
      onSubmit(quiz_data);
    }
  };

  const AutoSaveAssessmentSubmit = () => {
    const timer = window.sessionStorage.getItem(
      "timer" + data.student_assessment_id
    );
    data &&
      data.sections &&
      data.sections.forEach((section) => {
        section &&
          section.pages &&
          section.pages.forEach((page) => {
            if (size(page.exercises) > 0) {
              page &&
                page.exercises &&
                page.exercises.forEach((exercise) => {
                  let found_page = find(answers, ["page_id", page.id]);
                  let found_exercise = find(answers, [
                    "exercise_id",
                    exercise.id,
                  ]);
                  if (!found_page && !found_exercise) {
                    answers.push({
                      section_id: section.id,
                      page_id: page.id,
                      exercise_id: exercise.id,
                      answers: [],
                    });
                  } else if (size(exercise.questions) > 0) {
                    exercise &&
                      exercise.questions?.forEach((question) => {
                        if (question.type === "FillInBlank") {
                          let found_from_answer = find(answers.answers, [
                            "question_id",
                            question.id,
                          ]);
                          if (found_from_answer) {
                            question.prompt_content.replace(
                              /\[\[[^\]]*\]\]/g,
                              function replacer(matched) {
                                let number = parseInt(matched.match(/\d+/)[0]);
                                let found_from_selected_answers = find(
                                  found_from_answer.selected_answers,
                                  ["number", number]
                                );
                                if (!found_from_selected_answers) {
                                  found_from_answer.selected_answers.push({
                                    number: number,
                                    answer: "",
                                  });
                                }
                              }
                            );
                          }
                        }
                      });
                  }
                });
            } else if (size(page.writing_exercises) > 0) {
              page &&
                page.writing_exercises &&
                page.writing_exercises.forEach((exercise) => {
                  let found_page = find(answers, ["page_id", page.id]);
                  let found_exercise = find(answers, [
                    "exercise_id",
                    exercise.id,
                  ]);
                  if (!found_exercise && !found_page) {
                    answers.push({
                      section_id: section.id,
                      page_id: page.id,
                      exercise_id: exercise.id,
                      answers: "",
                    });
                  }
                });
            }
          });
      });
    const spent_timer = parseInt(data.time_allowed_in_minutes * 60 - timer);
    let quiz_data = {
      auto_save: true,
      is_submit: true,
      time_spent: parseInt(spent_timer),
      assessment_id: data.id,
      student_assessment_payload: answers,
    };
    setIsStopTimer(true);
    onSubmit(quiz_data);
    setIsSubmit(true);
    changed_is_submit_state = true;
    waitToggle();
    setShowWarnings(false);
  };

  ElabSubmissionStatus(isSubmit, data, setMessage, setIsSystemRedirection);
  SaveQuizOnRefresh(isReview, data, AutoSaveAssessmentSubmit, AssessmentSave, showWarning);

  const { handleSubmit } = useForm();

  const onFormSubmit = (isShowWarning=null) => {
    if (
      (data.task_type === exerciseType.PRONUNCIATION_TASK && IsonRecorder) ||
      (data.type === type.Assessment && IsonRecorder)
    ) {
      toast.error("Recorder is on, first stop recording then submit quiz", {
        position: "top-right",
        autoClose: true,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        toastId: 1,
      });
    } else if (
      data.assessment_flow === assessmentFlow.SEQUENTIAL_EARLY_STOP &&
      data?.sections && size(data?.sections[0].pages?.[0]?.writing_exercises) > 0 &&
      data?.sections[0].pages?.[0]?.writing_exercises?.[0]?.adhere_to_word_count &&
      (essayWordsCount < data?.sections[0].pages?.[0]?.writing_exercises?.[0]?.min_words || essayWordsCount > data?.sections[0].pages?.[0]?.writing_exercises?.[0]?.max_words)
    ) {
      toast.error(
        `Answer length must be between ${data?.sections[0].pages?.[0]?.writing_exercises?.[0]?.min_words} and ${data?.sections[0].pages?.[0]?.writing_exercises?.[0]?.max_words} words, current words are: ` +
          essayWordsCount,
        {
          position: "top-right",
          autoClose: false,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          toastId: 1,
        }
      );
    } else if (
      data.assessment_flow === assessmentFlow.SEQUENTIAL_EARLY_STOP &&
      data?.sections && size(data?.sections[0].pages?.[0]?.writing_exercises) > 0 &&
      !data?.sections[0].pages?.[0]?.writing_exercises?.[0]?.adhere_to_word_count &&
      (essayWordsCount < 100 || essayWordsCount > 1000)
    ) {
      toast.error(
        `Answer length must be between 100 and 1000 words, current words are: ` +
          essayWordsCount,
        {
          position: "top-right",
          autoClose: false,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          toastId: 1,
        }
      );
    }  else {
      let notAnswered;
      notAnswered = AssessmentWarnings(data, answers);
      if(isShowWarning === DirectSubmission){
        creatQuizDataAndSubmit();
      }
      else if (size(notAnswered) > 0) {
        setNotAnsweredQuestions(notAnswered);
        setModal(!modal);
      } else if (
        data.assessment_flow === assessmentFlow.SEQUENTIAL_EARLY_STOP && size(data.sections_pages) > 1
      ) {
        creatQuizDataAndSubmit();
      } else {
        setSaveModal(!saveModal);
      }
    }
  };

  const AssessmentPayLoadMaker = (e) => {
    AssessmentPayLoadMakerHelper(e, answers);
    AssessmentSave();
  };
  const btnsystemModal = document.getElementById("Systemtest");
  const smsystemModal = document.getElementById("smSystemtest");
  btnsystemModal?.addEventListener("click", function (e) {
    systemrequirementToggle();
  });
  smsystemModal?.addEventListener("click", function (e) {
    systemrequirementToggle();
  });

  if (data?.status === "New") {
    AssessmentStatusChangeCall();
  }


  return (
    <div className="min-h-screen bg-gray-50">
       
      <form onSubmit={handleSubmit(onFormSubmit)}>
        <MobileViewProvider>
        <>
          <ElabAssessmentRunner
            assessmentStarted={assessmentStarted}
            isReview={isReview}
            data={data}
            IsonRecorder={IsonRecorder}
            setIsonRecorder={setIsonRecorder}
            isStopTimer={isStopTimer}
            setIsStopTimer={setIsStopTimer}
            timer={assessmentTimer}
            resetAudio={resetAudio}
            setresetAudio={setresetAudio}
            isOpenAdditionalResourceModal={isOpenAdditionalResourceModal}
            setOpenAdditionalResourceModal={setOpenAdditionalResourceModal}
            additionalResourceToggle={additionalResourceToggle}
            questions={questions}
            currentPage={currentPage}
            onblur={AssessmentPayLoadMaker}
            answers={answers}
            setCurrentPage={setCurrentPage}
            creatQuizDataAndSubmit={AutoSaveAssessmentSubmit}
            setShowTimeWarning={setShowTimeWarning}
            visualizerToggle={visualizerToggle}
            isSubmitting={isSubmitting}
            setessayWordsCount={setessayWordsCount}
            FormSubmit={onFormSubmit}
          />
          <ToastContainer />
        </>
        </MobileViewProvider>
      </form>
      <ShowWarningsModal
          notAnsweredQuestion={notAnsweredQuestion}
          modal={modal}
          toggle={toggle}
          data={data}
          creatQuizDataAndSubmit={creatQuizDataAndSubmit}
      />
         <ConfirmationModal
                  isOpen={saveModal}
                  toggle={saveToggle}
                  onClick={creatQuizDataAndSubmit}
                />

         <ElabWaitModel
                  data={data}
                  isOpen={waitModal}
                  toggle={waitToggle}
                  message={message}
                  level={data.level}
                />
          <VisualizerModel isOpen={visualizerModal} toggle={visualizerToggle} />
          <SystemRequirementsModal
            data={data}
            isOpen={systemrequirementModal}
            toggle={systemrequirementToggle}
            setAssessmentStarted={setAssessmentStarted}
          />
    </div>
  )
}